export enum ERole {
    admin = 'Admin',
    member = 'Member',
    Facility_Staff_Member = 'Facility_Staff_Member',
    Employer_Facilitator = 'Employer_Facilitator'
}